import classNames from 'classnames';

const InputNew = ({ label, isRequired = false, name, type = 'text', placeholder, value, onChange, error }) => {
  return (
    <div className="flex flex-col gap-[6px]">
      <div className="w-full flex flex-col gap-[16px]">
        <label className="md:text-[18px] text-[16px] font-normal leading-[22px] text-white" htmlFor={name}>
          <span> {label} </span>
          {isRequired && <span className="text-[#ED1C24]">*</span>}
        </label>
        <div className="flex flex-row gap-[8px] w-full">
          {name === 'phone' && <div className="px-[16px] py-[17px] text-[#000000] bg-white rounded-[10px] h-[56px]">+374</div>}
          <input
            type={type}
            name={name}
            id={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            autoComplete="off"
            className={classNames(
              'bg-white w-full rounded-10 focus:outline-none focus:placeholder-transparent placeholder-[#BAB9B9] text-[16px] px-[24px] py-[16px]',
              error && '!bg-[#FFD5D6]'
            )}
          />
        </div>
      </div>
      {error && <span className="text-[#ED1C24] animate-warning text-[12px] ml-[20px]">{error}</span>}
    </div>
  );
};

export default InputNew;
